import { Component, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NgxFileDropEntry } from "ngx-file-drop";
import { RoTProvider } from "src/app/providers";
import { LogService } from "src/app/services";

@Component({
  selector: "app-rot-parsar",
  templateUrl: "./rot-parsar.component.html",
  styleUrls: ["./rot-parsar.component.scss"],
})
export class RotParsarComponent implements OnInit {
  loading: boolean = false;
  isSuccess: boolean = false;
  isError: boolean = false;
  errorMessage: string = "";
  subscription: any;
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private rotProvider: RoTProvider,
    private logService: LogService
  ) {}

  ngOnInit(): void {
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === "esc") this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  onCancel(): void {
    this.bsModalRef.hide();
  }

  fileDropped(files: NgxFileDropEntry[]): void {
    this.loading = true;
    const formData = new FormData();
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          formData.append("file", file);
        });
      }
    }

    this.rotProvider.postRot(formData).subscribe(
      (data) => {
        if (data.success) {
          this.loading = false;
          this.isSuccess = true; // Set success flag to true
        } else {
          this.loading = false;
          this.isError = true;
          this.errorMessage =
            data.error?.txt || "Something went wrong! Please try again.";
        }
      },
      (err) => {
        this.logService.error(err);
        this.loading = false;
        this.bsModalRef.hide();
      }
    );
  }
}
